import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestSection() {
  const [activeTab, setActiveTab] = useState('all');
  const tabs = [
    { label: '全部', value: 'all' },
    { label: '漫画', value: 'manhua' },
    { label: '小说', value: 'xiaoshuo' },
    { label: '画集', value: 'huaji' },
    { label: 'CP同人', value: 'cp' },
    { label: '活动', value: 'huodong' },
  ];

  const filtered = activeTab === 'all'
    ? articles
    : articles.filter((a) => a.categorySlug === activeTab);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新投稿
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">
            实时更新，发现来自同人创作者们的最新力作
          </p>
        </div>

        <div className="flex items-center justify-center mb-8">
          <div className="inline-flex items-center bg-background-100 rounded-full px-1 py-1">
            {tabs.map((tab) => (
              <button
                key={tab.value}
                onClick={() => setActiveTab(tab.value)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeTab === tab.value
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:ring-2 hover:ring-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-secondary-500 text-background-50">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}